import { render, staticRenderFns } from "./Inn.vue?vue&type=template&id=16dad026&"
import script from "./Inn.vue?vue&type=script&lang=js&"
export * from "./Inn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports